/** Browser screen commands. Dismissals are mediated by the mounted Sheet guards;
 * no command ends a voice session or follows browser history outside the app. */
export const BEFORE_SCREEN_NAVIGATION = 'mucka-before-screen-navigation';
export const CLOSE_SCREEN_VIEW = 'mucka-close-screen-view';
export const CLOSE_SCREEN_CHROME = 'mobile-modals-close';
export const CANCEL_PENDING_SCREEN_OPEN = 'mucka-cancel-pending-screen-open';
export const OPEN_JOB_PREVIEW = 'mucka-open-job-preview';
export interface OpenJobPreviewDetail { id: string; accepted?: boolean }
export function cancelPendingScreenOpen() {
  window.dispatchEvent(new CustomEvent(CANCEL_PENDING_SCREEN_OPEN));
}
export type ScreenAction = 'close' | 'back';
export type ScreenCloseDetail = { outcome?: 'closing' | 'unsaved' | 'busy'; helpSlug?: string };

export function mayNavigateScreen(): boolean {
  return window.dispatchEvent(new CustomEvent(BEFORE_SCREEN_NAVIGATION, { cancelable: true }));
}

export function requestScreenClose(): ScreenCloseDetail {
  const detail: ScreenCloseDetail = {};
  window.dispatchEvent(new CustomEvent(CLOSE_SCREEN_VIEW, { detail }));
  return detail;
}

export function closeScreenView(): ScreenCloseDetail['outcome'] { return requestScreenClose().outcome; }
